module.exports = __webpack_public_path__ + "static/media/bathroom.5989ee2f.png";